<script setup>
// D15: an entrant whose membership has lapsed (or who was added by an admin
// without one) stays in; admins see this chip on their entrant lists. The ids
// come from the detail's `playersWithoutMembership` (restricted rules only).
defineProps({
  // The server's line when there is one ("Alex has no Senior membership"); the chip says the short form.
  line: {type: String, default: null},
  size: {type: String, default: 'small'},
});
</script>

<template>
  <span class="tl-chip tl-chip--warn nmc" :class="{'nmc--xs': size === 'x-small'}" data-testid="no-membership-chip">
    <v-icon size="12" icon="mdi-card-account-details-outline" class="mr-1"/>No current membership
    <v-tooltip activator="parent" location="top">{{ line || 'No current membership or pass that lets them enter. They stay in; add one from Memberships & passes.' }}</v-tooltip>
  </span>
</template>

<style scoped>
.nmc { white-space: nowrap; }
.nmc--xs { font-size: 10px; padding: 1px 7px; line-height: 16px; }
</style>
